/**
 * The base colors for the Soft UI Dashboard PRO React.
 * You can add new color using this file.
 * You can customized the colors for the entire Soft UI Dashboard PRO React using thie file.
 */

const colors = {
  background: {
    default: "#F2F6F9"
    // default: "#05111f",
  },

  text: {
    main: "#000000",
    focus: "#1d1d1dff"
  },

  transparent: {
    main: "rgba(0,0,0,0)"
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
    placeholder: "#ffffffff"
  },

  black: {
    light: "#141414",
    main: "#000000",
    focus: "#000000"
  },

  primary: {
    main: "#7443FF",
    focus: "#A889FF"
  },

  secondary: {
    main: "#303030",
    focus: "#96a2b8"
  },

  info: {
    main: "#7443FF",
    focus: "#A889FF"
  },

  success: {
    main: "#7ed4a0",
    focus: "#95dc39"
  },

  warning: {
    main: "#fbcf33",
    focus: "#fcd652"
  },

  error: {
    main: "#c10a0a",
    focus: "#c70505"
  },

  light: {
    main: "#e9ecef",
    focus: "#dee2e6"
  },

  dark: {
    main: "#292c31ff",
    focus: "#292d34ff"
  },

  grey: {
    100: "#f8f9fa",
    200: "#e9ecef",
    300: "#dee2e6",
    400: "#ced4da",
    500: "#adb5bd",
    600: "#6c757d",
    700: "#495057",
    800: "#343a40",
    900: "#212529"
  },

  gradients: {
    primary: {
      main: "#7443FF",
      state: "#7928ca"
    },

    secondary: {
      main: "#627594",
      state: "#a8b8d8"
    },

    info: {
      main: "#7928ca",
      state: "#7443FF"
    },

    success: {
      main: "#17ad37",
      state: "#98ec2d"
    },

    warning: {
      main: "#f53939",
      state: "#fbcf33"
    },

    error: {
      main: "#ea0606",
      state: "#ff667c"
    },

    light: {
      main: "#fff",
      state: "#fff"
    },

    dark: {
      main: "#141727",
      state: "#1f2024"
    },
    purple: {
      main: "#7443FF",
      state: "#62D9FF"
    }
  },

  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#344e86"
    },

    twitter: {
      main: "#55acee",
      dark: "#3ea1ec"
    },

    instagram: {
      main: "#125688",
      dark: "#0e456d"
    },

    linkedin: {
      main: "#0077b5",
      dark: "#00669c"
    },

    pinterest: {
      main: "#cc2127",
      dark: "#b21d22"
    },

    youtube: {
      main: "#e52d27",
      dark: "#d41f1a"
    },

    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2"
    },

    slack: {
      main: "#3aaf85",
      dark: "#329874"
    },

    dribbble: {
      main: "#ea4c89",
      dark: "#e73177"
    },

    github: {
      main: "#24292e",
      dark: "#171a1d"
    },

    reddit: {
      main: "#ff4500",
      dark: "#e03d00"
    },

    tumblr: {
      main: "#35465c",
      dark: "#2a3749"
    }
  },

  alertColors: {
    primary: {
      main: "#7928ca",
      state: "#d6006c",
      border: "#efb6e2"
    },

    secondary: {
      main: "#627594",
      state: "#8ca1cb",
      border: "#dadee6"
    },

    info: {
      main: "#2152ff",
      state: "#02c6f3",
      border: "#b9ecf8"
    },

    success: {
      main: "#17ad37",
      state: "#84dc14",
      border: "#daf3b9"
    },

    warning: {
      main: "#f53939",
      state: "#fac60b",
      border: "#fef1c2"
    },

    error: {
      main: "#ea0606",
      state: "#ff3d59",
      border: "#f9b4b4"
    },

    light: {
      main: "#ced4da",
      state: "#d1dae6",
      border: "#f8f9fa"
    },

    dark: {
      main: "#141727",
      state: "#2c3154",
      border: "#c2c8d1"
    }
  },

  badgeColors: {
    primary: {
      background: "#f883dd",
      text: "#a3017e"
    },

    secondary: {
      background: "#e4e8ed",
      text: "#5974a2"
    },

    info: {
      background: "#EDF2F7",
      text: "#bec3c9ff"
    },

    customInfo: {
      background: "#EDF2F7",
      text: "#5B677C"
    },

    success: {
      background: "#09A74B",
      text: "#D9FFE5"
    },

    warning: {
      background: "#FFD584",
      text: "#7F6127"
    },

    error: {
      background: "#f2cece",
      text: "#bd0000"
    },

    light: {
      background: "#ffffff",
      text: "#c7d3de"
    },

    dark: {
      background: "#8097bf",
      text: "#1e2e4a"
    },

    recurring: {
      background: "#800080",
      text: "#ffffff"
    },

    executing: {
      background: "#FFFF00",
      text: "#495057"
    },
    canceling: {
      background: "#FFA500",
      text: "#ffffff"
    },

    completed: {
      background: "#ADD8E6",
      text: "#495057"
    },

    paused: {
      background: "#808080",
      text: "#ffffff"
    }
  },

  inputColors: {
    borderColor: { main: "#d2d6da", focus: "#35d1f5" },
    boxShadow: "#7443FF",
    error: "#fd5c70",
    success: "#66d432"
  },

  sliderColors: {
    thumb: { borderColor: "#d9d9d9" }
  },

  circleSliderColors: {
    background: "#d3d3d3"
  },

  tabs: {
    indicator: { boxShadow: "#ddd" },
    background: "#E6E6E6E6"
  }
};

export default colors;
